module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bold",
    attrs: {
      "id": "base"
    }
  }, [_c('app-header'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "bounce"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29a796ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Base.vue
// module id = 82
// module chunks = 0